export default "__VITE_ASSET__zin0AWe1__"